import { Heading } from '@core/ui';

import { AuthPageTitleProps } from './types';

export const AuthPageTitle = ({ children, className, testId }: AuthPageTitleProps) => (
    <Heading data-testid={testId} variant="h1" classNames={`${className}`}>
        {children}
    </Heading>
);
